<template>
<v-container>
    <h1 class="title mb-3 text-center">ISI vragenlijst</h1>
    <v-stepper v-model="e1" class="mb-5">
      <v-stepper-header>
        <template v-for="(step, n) in steps"> 
          <v-stepper-step :complete="e1 > step.id" :step="step.id" :key="n"></v-stepper-step>

          <v-divider v-if="n !== (steps.length - 1)" :key="'divider' + n"></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items class="questionaire">
          <v-stepper-content :step="step.id" v-for="(step, n) in steps" :key="n">
            <v-container fill-height>
              <v-layout row wrap align-center>
                <v-flex class="text-center">
                  <h3 class="mb-5" v-html="step.question"></h3>
                  <v-rating 
                      v-model="step.answer"
                      :dense="$vuetify.breakpoint.xs"
                      x-large
                      @input="select">
                      <template v-slot:item="props">
                      <v-icon
                        :color="props.isFilled ? 'white' : 'grey lighten-1'"
                        large
                        @click="props.click" >
                        {{ props.isFilled ? 'mdi-star-circle' : 'mdi-circle-outline' }}
                      </v-icon>
                    </template>
                  </v-rating>
                  <v-flex class="d-flex justify-space-between">
                    <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                    <small class="text-left">{{step.min}}</small>
                    <v-spacer></v-spacer>
                    <small class="text-right">{{step.max}}</small>
                    <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-stepper-content>
          <v-stepper-content :step="steps.length + 1">
              <v-container fill-height>
                <v-layout row wrap align-center class="pa-3">
                  <v-flex class="text-center">
                    <h3 class="mb-5 title" >Uw Score</h3>
                    <p class="display-2">{{score}}</p>
                    <p v-if="score <= 7">Geen sprake van klinisch significante slapeloosheid.</p>
                    <p v-if="score > 7 && score <= 14">U zit tegen slapeloosheid aan. Probeer eens het slaaplogboek bij te houden en/of schakel een slaapexpert in.</p>
                    <p v-if="score > 14 && score <= 21">Er is sprake van klinische slapeloosheid (matige ernst). Raadpleeg uw huisarts of schakel een expert in.</p>
                    <p v-if="score > 21">Er is sprake van ernstige klinische slapeloosheid. Raadpleeg uw huisarts en schakel een slaapexpert in.</p>
                  </v-flex>
                </v-layout>
              </v-container>
              <div class="text-center mb-3">
                <email name="ISI" :steps="steps" :score="score" color="primary"></email><br/>
                <expert v-if="score > 7" color="warning" ></expert>
              </div>
          </v-stepper-content>
      </v-stepper-items>
  </v-stepper>
  <div class="text-center mb-5">
    <v-btn dark @click="reset">Opnieuw beginnen</v-btn>
  </diV>
  <v-alert color="primary" outlined >
      De ISI vragenlijst wordt gebruikt om de ernst van slapeloosheidsklachten te meten. Bovenstaande vragen gaan over <strong>hoe u uw slaap ervaart.</strong>
    </v-alert>
</v-container>
</template>

<script>
import Email from '@/components/questionaires/email';
import Expert from '@/components/Expert';
  export default {
    name: "isi-questionaire",
    components: {
      Email,
      Expert
    },
    data () {
      return {
        e1: 1,
        completed: false,
        steps: [
          {
            id: 1,
            question: "Had u de afgelopen twee weken moeite met inslapen?<br /><small>Geef de ernst van uw slaapprobleem aan.</small>",
            min: "Geen",
            max: "Zeer ernstig",
            answer: 0
          },
          {
            id: 2,
            question: "Had u de afgelopen twee weken moeite met doorslapen?<br /><small>Geef de ernst van uw slaapprobleem aan.</small>",
            min: "Geen",
            max: "Zeer ernstig",
            answer: 0
          },
          {
            id: 3,
            question: "Had u de afgelopen twee weken problemen met vroeg wakker worden?<br /><small>Geef de ernst van uw slaapprobleem aan.</small>",
            min: "Geen",
            max: "Zeer ernstig",
            answer: 0
          },
          {
            id: 4,
            question: "Hoe tevreden bent u met uw huidige slaappatroon?",
            min: "Zeer tevreden",
            max: "Zeer ontevreden",
            answer: 0
          },
          {
            id: 5,
            question: "In hoeverre beïnvloeden uw slaapproblemen uw dagelijks functioneren? (bijvoorbeeld vermoeidheid, concentratie, geheugen en stemming)",
            min: "Geen negatieve invloeden",
            max: "Zeer veel negatieve invloeden",
            answer: 0
          },
          {
            id: 6,
            question: "Hoe opvallend zijn de dagelijkse gevolgen van uw slaapproblemen voor anderen?",
            min: "Helemaal niet opvallend",
            max: "Heel erg opvallend",
            answer: 0
          },
          {
            id: 7,
            question: "Hoe ongerust bent u over uw huidige slaapproblemen?",
            min: "Helemaal niet ongerust",
            max: "Heel erg ongerust",
            answer: 0
          }
        ]
      }
    },
    methods: {
      reset() {
        this.steps.forEach((s) => { return s.answer = 0 });
        this.e1 = 1;
      },
      select(value)
      {
        this.steps[this.e1 - 1].answer = value;
        setTimeout(() => {
          this.e1++;
          if(this.e1 > this.steps.length)
          {
            this.completed = true;
            this.save();
          }
        }, 100);
      },
      save()
      {
        let q = {
          name: "ISI",
          score: this.score,
          json: JSON.stringify(this.steps)
        };

        this.$http.post("api/Questionaire", q);
      }
    },
    computed: {
      score() {
        return this.steps.reduce((a, b) => { return a + ((b.answer > 0) ? b.answer - 1 : b.answer) }, 0)
      }
    }
  }
</script>

<style scoped>
.questionaire {
  color: white;
  background-color: #46555e !important;
  border-color: #46555e !important;
}
</style>